module.exports = __webpack_public_path__ + "static/doit.logo-a6062708ab79487f52a4b9c8401e0a0d.jpg";